<template>
  <div class="com-file" >
    <i class="icon-file" :class="iconName"></i>
    <div  class="file-info" :style="{width:width?width+'px':'auto'}">
      <a-tooltip placement="topLeft">
      <template slot="title">
        <span>{{ file.fileName }}</span>
      </template>
      <div class="file-name">
        <span>{{ firstName }}</span>
        <!-- <span>{{ lastName }} &nbsp;({{ fileSize }})</span> -->
        <span>{{ lastName }}</span>
      </div>
    </a-tooltip>
    </div>
    <!-- <div class="file-size">&nbsp;({{ fileSize }})</div> -->
    <i v-if='isDownload' class="icon-file download"  @click="handleDownLoad"></i>
    <i v-if='isDelete' class="icon-file delete"  @click="handleDelete"></i>
  </div>
</template>

<script>
//公共文件组件
// fileDownload,downloadAttUrl
import {_ctxPath} from '@/api/http';
// import {_ctxPath} from '@/api/file';
import { getFileTypeByFileName,formatFileSize } from '@/util/file.js';
export default {
  name: 'ComFile',
  props: {
    file:{
      type:Object,
      required:true,
      default:()=>{}
    },
    // isUpload: {
    //   type: Boolean,
    //   default: false
    // },
    width:{
      type:[String,Number]
    },
    isDownload: {
      type: Boolean,
      default: false
    },
    isDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      firstName: '',
      lastName: ''
    };
  },
  computed: {
    fileSize() {
      return formatFileSize(this.file.fileSize);
    },
    iconName(){
      return getFileTypeByFileName(this.file.fileName);
    }
  },
  mounted() {
    const suffixIndex = this.file.fileName.lastIndexOf('.');
    let firstName = this.file.fileName.slice(0, suffixIndex);
    let lastName = this.file.fileName.slice(suffixIndex);
    if (firstName.length > 3) {
      lastName = `${firstName.slice(-3)}${lastName}`;
      firstName = firstName.slice(0, -3);
    }
    this.firstName = firstName;
    this.lastName = lastName;
  },
  methods:{
    handleDownLoad(){
      console.log(this.file);
      window.open(_ctxPath+this.file.url);
      // fileDownload(this.file.id).then(res=>{
      //   console.log('res',res);
      // })
    },
    handleDelete(){
      this.$emit('delete',this.file);
    }
  }
};
</script>

<style lang="less" scoped>
.com-file {
  position: relative;
  width: auto;
  padding:0 8px;
  display: inline-flex;
  justify-content: flex-start;
  align-items:center;
  user-select: none;
  height: 24px;
  border-radius: 3px;
  color:#111111;
  background: #F1F5F9;
  .icon-file{
    display:inline-block;
    margin-right:10px;
    width:20px;
    height:20px;
  }
  .word{
    background: url('../../assets/images/icon_file_word.png') center top/cover no-repeat;
  }
  .excel{
    background: url('../../assets/images/icon_file_excel.png') center top/cover no-repeat;
  }
  .pdf{
    background: url('../../assets/images/icon_file_pdf.png') center top/cover no-repeat;
  }
  .txt{
    background: url('../../assets/images/icon_file_txt.png') center top/cover no-repeat;
  }
  .other{
    background: url('../../assets/images/icon_file_other.png') center top/cover no-repeat;
  }
  .zip{
    background: url('../../assets/images/icon_file_zip.png') center top/cover no-repeat;
  }
  .upload{
    background: url('../../assets/images/icon_file_upload.png') center top/cover no-repeat;
  }
  .image{
    background: url('../../assets/images/icon_file_image.png') center top/cover no-repeat;
  }
  .ppt{
    background: url('../../assets/images/icon_file_ppt.png') center top/cover no-repeat;
  }
  .download{
    transform:scale(0.8);
    margin-left: 5px;
    cursor:pointer;
    background: url('../../assets/images/icon_file_download.png') center top/cover no-repeat;
  }
  .delete{
    transform:scale(0.8);
    margin-left: 5px;
    cursor:pointer;
    background: url('../../assets/images/icon_file_delete.png') center top/cover no-repeat;
  }
}
.file-info {
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .file-name {
    max-width: 100%;
    display: flex;
    :first-child {
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      white-space: nowrap;
      white-space: pre;
    }
    :last-child {
      display: block;
      word-break: keep-all;
      white-space: pre;
    }
  }
}
</style>
